var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcConvertDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1 -1 0 40 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#1F63FF",
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.415 3.237a1.875 1.875 0 0 0 -2.58-2.721l-5.835 5.527-5.835-5.527a1.875 1.875 0 0 0 -2.58 2.721l7.125 6.749a1.875 1.875 0 0 0 2.58 0z",
    fill: "#fff",
    transform: "matrix(0 -1 1 0 15.5 29)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConvertDown);
export default __webpack_public_path__ + "static/media/ic_convert_down.3286d571746ea016fe66161e532a4882.svg";
export { ForwardRef as ReactComponent };